import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

export default function useProfileTheme() {
  const theme = useTheme();
  return useMemo(
    () => ({
      accent: theme.palette.chat,
      shadows: theme.customTokens?.shadows,
      semantic: theme.customTokens?.semantic,
    }),
    [theme]
  );
}
